<template>
    <div>
      <Head title="Gestão de Funcionários" />
      <div class="shadow_box rounded-lg p-6">
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Gestão de Especialidades - B2B</h1>
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Configuração: {{ seeting.name }}</h1>
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Empresa: {{ seeting.company }}</h1>
        <data-table v-if="loadTable" search-label="Pesquisar por nome da especialidade"
          v-model:columns="columns" :route="'/seetings-services-specialties/list/' + seeting.id"
          no-data-label="Nenhuma especialidade encontrada" no-result-label="Nenhuma especialidade encontrada">
          <template #table.cell.content.specialty_unlimited="{ value, row }">
            <div v-if="row.unlimited">Sim</div>
            <div v-if="!row.unlimited">Não</div>
            <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
          </template>
          <template #grid.content.body.specialty_unlimited="{ value, row }">
            <div v-if="row.unlimited">Sim</div>
          <div v-if="!row.unlimited">Não</div>
            <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
          </template>
          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">                
              <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
              <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
              <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
              <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
          </template>
  
          <template #after.reload-button>            
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click="openModalConfig()">
                <font-awesome-icon icon="fa-upload" class="text-purple text-sm mr-0 lg:mr-2" />Reordenar prioridades
            </button>

            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Adicionar Especialidade</span>
            </button>
          </template>
        </data-table>
      </div>
      <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
      <modal-edit 
      :modal-scrollable="true" 
      ref="modalEdit" title="Especialidade" 
      url="seetings-services-specialties" @submitForm="reloadTable" :item="{specialty_id: null, photo: {},}" :multipart="true">
        <template #form="{item}">          
          
          <select-input v-model="item.specialty_id" :error="item.errors.specialty_id" class="lg:pr-6 mt-6 w-full lg:w-1/3" placeholder="Especialidade" label="Especialidade">
            <option :value="null" disabled class="hidden invisible">Especialidade</option>
            <option v-for="(value, name, index) in specialtiesAdded" :key="value.name" :value="value.id">
              {{ value.name }}
            </option>
          </select-input>
          <text-input :disabled="item.unlimited" type="number" min="0" v-model="item.quantity" :error="item.errors.quantity" class="lg:pr-6 mt-6 w-full lg:w-1/3" label="Quantidade" />
          <label class="flex items-center mt-6 w-full lg:w-1/3 select-none" for="unlimited">
            <input id="unlimited" v-model="item.unlimited" class="mr-1" type="checkbox" @click="IlimitedSpeciality(item)" />
            <span class="text-sm">Ilimitado</span>
          </label>
          <textarea-input v-model="item.description" :error="item.errors.description" class="lg:pr-6 mt-6 w-full" label="Descrição" />
          <photo-input v-model="item.photo" :error="item.errors[`photo.upload`]" class="lg:pr-6 w-full" type="file" label="Foto" /> 

          
        </template>
      </modal-edit>
      <modal ref="modalDeleteInactive" :modal-scrollable="true" :modal-backdrop="true">
        <template #body>
          <div class="text-center">
            <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
            <div class="mt-4 mb-4">
              Deseja realmente excluir a especialidade.
            </div>
            <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="this.$refs.modalDeleteInactive.showModal = false">Ok</button>
          </div>
        </template>
      </modal>
      <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Especialidades - Ordenação</span>
            </div>
        </template>
        <template #body>
          <form action="">
            <div class="flex justify-center">
              <div class="w-full lg:w-1/2 m-2">
                <draggable class="list-group list-group-selected" itemKey="id" :list="this.formConfig.specialtiesOrdered">
                  <template #item="{element}">
                      <div class="mb-4 list-group-item">
                        {{element.name}}
                        <input type="hidden" name="selected" :value="element.id">
                      </div>
                    </template>
                </draggable>
              </div>
            </div>
          </form>
        </template>
        <template #footer>
            <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalConfig">Cancelar</button>
            <loading-button :loading="loadModalConfig" class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="saveModalConfig" type="submit">Salvar</loading-button>
        </template>
      </modal>
      


    </div>
</template>
  
<script>
import { computed } from "vue";
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "@/Shared/Layout/Layout";
import LoadingButton from "@/Shared/Components/LoadingButton";
import ModalDelete from "@/Shared/Modal/ModalDelete";
import ModalEdit from "@/Shared/Modal/ModalEdit";
import Modal from "@/Shared/Modal/Modal";
import DataTable from "@/Shared/Components/DataTable";
import SwitchInput from "@/Shared/Fields/SwitchInput";
import TextInput from "@/Shared/Fields/TextInput";
import EmailInput from "@/Shared/Fields/EmailInput";
import TextareaInput from "@/Shared/Fields/TextareaInput";
import PasswordInput from "@/Shared/Fields/PasswordInput";
import SelectInput from "@/Shared/Fields/SelectInput";
import MaskInput from "@/Shared/Fields/MaskInput";
import VueSelectInput from "@/Shared/Fields/VueSelectInput";
import PhotoInput from '@/Shared/Fields/PhotoInput';
import CepInput from "@/Shared/Fields/CepInput";
import PercentualInput from "@/Shared/Fields/PercentualInput";
import DateInput from "@/Shared/Fields/DateInput";
import draggable from 'vuedraggable';

export default {
  props: {
    specialties_options: Object,
    companies_options: Object,
    seeting_service_specialties: Object,
    seeting: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    Modal,
    DataTable,
    SwitchInput,
    TextInput,
    EmailInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
    TextareaInput,
    PhotoInput,
    CepInput,
    PercentualInput,
    DateInput,
    draggable,
  },
  layout: Layout,
  mounted() {
    this.loadOptions();
    
   
  },
  setup() {},
  data() {
    return {
      specialties_options_aux: [],
      seeting_service_specialties_aux: [],
      specialtiesOrdered: [],
      specialtiesAdded: [],
      loadTable: true,
      loadModalConfig: false,
      columns: [
        {
          uniqid: "specialty_name",
          label: "Especialidade",
          field: "specialty_name",
          visible: true,          
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.specialty_name}`,
        },
        {
          uniqid: "specialty_unlimited",
          label: "Ilmitado",
          field: "unlimited",
          visible: true,          
          classes:
            "px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis",
          headerClass: "p-4 text-left",
        },
        {
          uniqid: "specialty_quantity",
          label: "Quantidade",
          field: "quantity",
          visible: true,          
          classes:
            "px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis",
          headerClass: "p-4 text-left",
        },
        {
          uniqid: "actions",
          label: "Ações",
          field: "id",
          visible: true,
          align: "center",
          classes: "py-3 border-b",
          headerClass: "p-4",
        },
      ],
    };
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/seetings-services-specialties/update-status", {
        id: item.id,
        status: item.status,
      });
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(
        item,
        `/seetings-services-specialties/${item.id}`,
        `Deseja realmente excluir a configuração ${item.name}?`
      );
    },
    
    
    IlimitedSpeciality(item) {
      item.quantity = 0;
    },
    async deletar(seetingServiceSpecialty) {
      await fetch(
        `/seetings-services-specialties/delete-specialties/` + seetingServiceSpecialty.id
      ).then((res) => {
        res.json().then((json) => {
          this.sucess = json.sucess;
        });
      });
    },
    async openModalEdit(i) {

      await this.loadSpeacialtiesAddeds();

      let item = {
        
        id: i.id,
        specialty_id: i.specialty_id,
        unlimited: i.unlimited,
        quantity: i.quantity,
        description: i.description,
        seeting_id: this.seeting.id,
        photo: i.photo ?? {},
        


      };

      if (i){
        this.specialtiesAdded.push({ id: i.specialty_id, name: i.specialty_name });
      }

      

      
      //this.verifySpeacialtiesUser();

      this.$refs.modalEdit.openModalEdit(item);
    },
    verifySpeacialtiesUser() {
      
      if (this.$props.specialties_options) {
        this.$props.specialties_options.forEach((specialty) => {
          let japossui = false;
          
          
          if (this.specialtiesAdded) {
            
            
            this.specialtiesAdded.forEach((seetSpecialty) => {
              console.log('cai')
              console.log(seetSpecialty.id)
              console.log(specialty.id)
              
              if (seetSpecialty.id === specialty.id) {
                japossui = true;
              }
            });

            if (japossui == false) {
              this.specialties_options_aux.push({
                id: specialty.id,
                name: specialty.name,
              });
            }
          } 
          
          
        });

        
      }
    },
    
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => (this.loadTable = true), 10);
    },
    async openModalConfig() {
        
      await this.loadOptions();
      //console.log(this.specialtiesOrdered)
      this.formConfig = useForm({
        specialtiesOrdered: this.specialtiesOrdered,
      });
      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
    saveModalConfig() {
      this.formConfig.post(`/seetings-services-specialties/update-config`, {
        onFinish: () => {
          if(!Object.keys(this.formConfig.errors).length) {
            this.closeModalConfig();            
            this.reloadTable();

          } else {
            this.loadModalConfig = false;
          }
        }
      });
    },
    async loadOptions() {
        
        this.specialtiesOrdered.splice(0,this.specialtiesOrdered.length);
        
        
      await fetch(
        `/seetings-services-specialties/get-specialties-ordered/` + this.seeting.id
      ).then(res => {
        res.json().then(json => {
          if (Array.isArray(json.specialtiesOrdered)) {            
            json.specialtiesOrdered.forEach((specialty) => {
              this.specialtiesOrdered.push({ id: specialty.id, order: specialty.order, name: specialty.name });

            });
          }          
        });
      });

      
    },

    async loadSpeacialtiesAddeds() {
      
      this.specialtiesAdded.splice(0,this.specialtiesAdded.length);
      this.specialties_options_aux = [];
        
      await fetch(
        `/seetings-services-specialties/get-specialties-added/` + this.seeting.id
      ).then(res => {
        res.json().then(json => {
          if (Array.isArray(json.specialtiesAdded)) {            
            json.specialtiesAdded.forEach((specialty) => {
              this.specialtiesAdded.push({ id: specialty.id, name: specialty.name });

              console.log(this.specialties_options)
              
              if (this.specialties_options) {
                var japossui = false;
                
                this.specialties_options.forEach((seetSpecialty) => {

                 
                  
                  if (seetSpecialty.id === specialty.id) {
                    japossui = true;
                  }
                });

                if (japossui == false) {
                    this.specialties_options_aux.push({
                      id: specialty.id, name: specialty.name
                    });
                  }

                
              }
              
            });
          }          
        });
      });

      
    },
  },
};
</script>
<style>
  .list-group {
    @apply flex flex-col;
  }

  .list-group-item {
    @apply text-black
    relative block py-3 px-9 border cursor-move bg-gray-200
    hover:bg-gray-300;
  }
</style>